import type { CSSProperties } from 'react'

interface LiveWaveProps {
  bars?: number
  color?: string
  height?: number
}

/**
 * 动态生成中/录制中波形（每条柱体按延迟节奏跳动）
 * 复用 voice.css 中定义的 voice-wave-bounce 关键帧
 */
export const LiveWave = ({ bars = 32, color = 'white', height = 24 }: LiveWaveProps) => {
  return (
    <div
      className="flex items-center justify-center gap-0.5 h-[var(--lw-h)]"
      style={{ '--lw-h': `${height}px` } as CSSProperties}
    >
      {Array.from({ length: bars }).map((_, i) => (
        <div
          key={i}
          className="h-full w-[2.5px] rounded-[2px] origin-center bg-[color:var(--lw-c)] animate-[voice-wave-bounce_1.2s_ease-in-out_var(--lw-d)_infinite]"
          style={
            {
              '--lw-c': color,
              '--lw-d': `${i * 0.04}s`,
            } as CSSProperties
          }
        />
      ))}
    </div>
  )
}
